export default __webpack_public_path__ + "static/media/mclaren-orange-big.46e3c615.png";